<template>

    <div class="modal" :class="classes">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <span class="modal-title ml-10">{{ title }}</span>
                    <v-close @click.native="closeModal" />
                </div>
                <div v-if="loading" class="modal-body">
                    <v-loader />
                </div>
                <div v-if="!loading && $slots['nav']" class="modal-nav">
                    <v-tab-bar><slot name="nav"></slot></v-tab-bar>
                </div>
                <div v-if="!loading && $slots['body']" class="modal-body">
                    <slot name="body"></slot>
                </div>
                <div v-if="$slots['footer'] && !loading" class="modal-footer">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>

</template>

<style lang="scss">

    body.modal-open {
        &::-webkit-scrollbar {
            display: none;
        }
    }

    .modal-backdrop {
        background: rgba(0,0,0,0.7);
        height: 100%;
        left: 0;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 999;
    }

</style>

<style scoped lang="scss">

    .modal {

        border-radius: 0;
        display: block;
        height: 100%;
        left: 0;
        outline: 0;
        overflow: auto;
        padding: 0;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 10001;

        &.fullscreen {
            .modal-dialog {
                height: calc(100% - 20px);
                left: 0;
                margin: 10px;
                width: calc(100% - 20px);
            }
            .modal-content {
                height: 100%;
            }
            .modal-body {
                overflow: auto;
                padding: 0;
            }
        }

        &.loading {
            .modal-body {
                align-items: center;
                display: flex;
                justify-content: center;
            }
        }

        .modal-dialog {
            @include shad(2);
            -webkit-overflow-scrolling: touch;
            background: #fff;
            border: none;
            border-radius: 5px;
            left: 50%;
            margin-left: -$screen-sm-min / 2;
            margin-top: 30px;
            max-width: 100%;
            padding: 0;
            position: absolute;
            top: 0;
            width: $screen-sm-min;
            @media only screen and (max-width: $screen-md-min) {
                left: 0;
                margin: 0;
                top: 0;
                width: 100%;
            }
        }

        .modal-content {
            border: none;
            display: flex;
            flex-direction: column;
        }

        .modal-header {
            align-items: center;
            background: #fff;
            border-bottom: 1px solid $color-rule-light;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            min-height: 60px;
            padding: 10px;
            position: relative;
        }

        .modal-title {
            @include font-semibold(16px);
            align-items: center;
            display: flex;
            line-height: normal;
        }

        .modal-nav {
            @include font-medium(14px);
            background: $color-bg;
            border-bottom: 1px solid $color-rule;
            display: flex;
            padding: 15px 10px;
        }

        .modal-body {
            border-radius: 0;
            flex: 1 1 auto;
            padding: 30px;
            position: relative;
            *:last-child {
                margin-bottom: 0;
            }
            p {
                @include font-medium(14px);
                line-height: 1.6em;
                margin: 0 0 10px 0;
                text-align: center;
                &.small {
                    font-size: 13px;
                }
            }
        }

        .modal-footer {
            background: $color-bg;
            border-top: 1px solid $color-rule;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            padding: 15px;
            *:only-child {
                margin-left: auto;
            }
        }

    }

</style>

<script>

export default {

    props: {
        title: {
            type: String,
            required: true,
        },
        loading: {
            type: Boolean,
        },
        fullscreen: {
            type: Boolean,
            required: false,
        },
    },

    computed: {

        classes() {
            return {
                loading: this.loading,
                fullscreen: this.fullscreen,
            }
        },

    },

    methods: {

        closeModal() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>
